import { useTranslation } from 'react-i18next';
import { AlertTriangle } from 'lucide-react';
import { Alert, AlertDescription } from '@/components/ui/alert';
import { Button } from '@/components/ui/button';
import { useAuthContext } from '@/contexts/AuthContext';
import { useStripePortal } from '@/hooks/useStripeBilling';

export function PastDueBanner() {
  const { t } = useTranslation();
  const { organization } = useAuthContext();
  const portalMutation = useStripePortal();

  if (organization?.subscription_status !== 'past_due') return null;

  return (
    <Alert variant="destructive" className="rounded-none border-x-0 border-t-0">
      <AlertTriangle className="h-4 w-4" />
      <AlertDescription className="flex items-center justify-between gap-4">
        <span>
          {t('billing.pastDue.message')}
        </span>
        <Button
          variant="outline"
          size="sm"
          onClick={() => portalMutation.mutate()}
          disabled={portalMutation.isPending}
          className="shrink-0"
        >
          {t('billing.pastDue.updatePayment')}
        </Button>
      </AlertDescription>
    </Alert>
  );
}
